import getUserPermissions from 'modules/get-user-permissions/get-user-permissions';
import { STATUSES } from 'constants/constants';

export function getUserAllowedStatuses() {
  const userPermissions = getUserPermissions();

  return Object.entries(STATUSES).reduce((accumulator, [key, value]) => {
    return {
      ...accumulator,
      ...(userPermissions.some((permission) =>
        value.allowedTo.includes(permission),
      ) && { [key]: value }),
    };
  }, {});
}
